import * as React from "react";
import PropTypes from "prop-types";
import prefixStyles from "./utils/prefixStyles";
import NoStyleButton from "./NoStyleButton";
import { IconCircledArrowUp, IconCircledArrowDown } from "./Icons";
import Tappable, { simpleActiveBackgroundColor } from "./Tappable";

const NumericUpDownPicker = ({
  children,
  onUp,
  onDown,
  upDisabled,
  downDisabled,
  style,
  upButtonStyle,
  downButtonStyle,
  childWrapperStyle,
  "aria-controls": ariaControls,
}) => {
  const iconStyle = {
    cursor: "pointer",
    width: 40,
    height: 40,
    outline: "none",
  };

  const styles = {
    container: prefixStyles({
      display: "flex",
      justifyContent: "space-between",
      ...style,
    }),
    button: {
      borderRadius: "50%",
    },
    upButton: {
      ...iconStyle,
      ...upButtonStyle,
      ...(upDisabled ? { opacity: "0.5" } : null),
    },
    downButton: {
      ...iconStyle,
      ...downButtonStyle,
      ...(downDisabled ? { opacity: "0.5" } : null),
    },
    childWrapper: prefixStyles({
      display: "flex",
      justifyContent: "center",
      alignContent: "center",
      flexDirection: "column",
      fontSize: 18,
      width: "auto",
      userSelect: "none",
      ...childWrapperStyle,
    }),
  };

  return (
    <div style={styles.container}>
      <Tappable onTap={onDown}>
        {({ tapTargetRefHandler, active }) => (
          <NoStyleButton
            disabled={downDisabled}
            innerRef={tapTargetRefHandler}
            aria-label="down"
            aria-controls={ariaControls}
            style={{
              ...styles.button,
              backgroundColor: simpleActiveBackgroundColor(active),
            }}
          >
            <IconCircledArrowDown style={styles.downButton} />
          </NoStyleButton>
        )}
      </Tappable>
      {children ? <span style={styles.childWrapper}>{children}</span> : null}
      <Tappable onTap={onUp}>
        {({ tapTargetRefHandler, active }) => (
          <NoStyleButton
            disabled={upDisabled}
            innerRef={tapTargetRefHandler}
            aria-label="up"
            aria-controls={ariaControls}
            style={{
              ...styles.button,
              backgroundColor: simpleActiveBackgroundColor(active),
            }}
          >
            <IconCircledArrowUp style={styles.upButton} />
          </NoStyleButton>
        )}
      </Tappable>
    </div>
  );
};
NumericUpDownPicker.propTypes = {
  children: PropTypes.node,
  onUp: PropTypes.func,
  onDown: PropTypes.func,
  upDisabled: PropTypes.bool,
  downDisabled: PropTypes.bool,
  style: PropTypes.object,
  upButtonStyle: PropTypes.object,
  downButtonStyle: PropTypes.object,
  childWrapperStyle: PropTypes.object,
  "aria-controls": PropTypes.string,
};

export default NumericUpDownPicker;



// WEBPACK FOOTER //
// ../nx-components/src/NumericUpDownPicker.jsx